
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---
import { Vehicle } from '@/models/Vehicle.model';

@Component
export default class AutoComplete extends Vue {
  @Prop() readonly model!: Vehicle;  
  @Prop({default: true}) readonly showTypeIndicator!: boolean;
  @Prop({default: true}) readonly showStatusIndicator!: boolean;
  @Prop({default: true}) readonly showIndicators!: boolean;
  @Prop({default: false}) readonly prependTypeIcon!: boolean;
  @Prop({default: ''}) readonly prependDefaultIcon!: string;

  selectedVehicle: Vehicle = Object.assign({}, this.$store.getters['vehicles/emptyVehicle']);

  @Watch('model', {
    immediate: true,
    deep: true,
  })
  resetVehicleToModel() {
    this.selectedVehicle = this.model;
  }

  @Watch('selectedVehicle', {
    immediate: true,
    deep: true,
  })
  changeVehicle() {
    this.$emit('select:vehicle', this.selectedVehicle);
  }

}
